import { Container } from '@cgs/wge';
import { CheatManager, CheatManagerToken } from '../cheat-manager';
import { CheatPopupElementToken } from './cheat-popup';
import { CheatUISection } from './cheat-ui-section';
import { getCheatUIStyles } from './styles';

export const CheatCustomInputToken = Symbol('CheatCustomInput');

export class CheatCustomInputUI extends CheatUISection {
  constructor(private container: Container) {
    super();

    const cheatCustomInput = this.container.resolve<boolean>(CheatCustomInputToken);

    if (!cheatCustomInput) {
      return;
    }

    this.container.resolve<CheatManager>(CheatManagerToken).subscribe((activeCheat) => {
      if (!activeCheat || activeCheat.length === 0) {
        this.resetUI();
      }
    });

    this.initialize();
  }

  public initialize(): void {
    const consoleEl = this.container.resolve<HTMLDivElement>(CheatPopupElementToken);

    this.initializeBaseUI(consoleEl);
    this.setupConfigsUI();
    this.setupConfigsEventListeners();
  }

  private setupConfigsUI(): void {
    const styles = getCheatUIStyles();
    const content = `<div style="${styles.sectionStyle}">
        <button id="applyCustomCheat" style="${styles.buttonStyle}">Apply</button>
        <input id="customCheat" type="text" placeholder="Custom cheat" style="${styles.inputStyle}">
      </div>`;

    this.contentEl.innerHTML = content;
  }

  private setupConfigsEventListeners(): void {
    const cheatManager = this.container.resolve<CheatManager>(CheatManagerToken);
    this.getChildEl('#applyCustomCheat')?.addEventListener('click', () => {
      const inputEl = this.getChildEl<HTMLInputElement>('#customCheat');
      if (inputEl && inputEl.value) {
        cheatManager.applyCustomCheat(inputEl.value);
      }
    });
  }

  private resetUI(): void {
    const inputEl = this.getChildEl<HTMLInputElement>('#customCheat')!;
    inputEl.value = '';
  }
}
